import React, { FC } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { transportDateHelper } from 'utils/transport-date-helper';
import { TransportLocation } from 'models/transport';

type TransportPointProps = {
    location: TransportLocation | undefined;
    isFrom: boolean;
    date: string;
};

const TransportPoint: FC<TransportPointProps> = ({ location, isFrom, date }: TransportPointProps) => {
    const { t: translate } = useTranslation(['transport', 'country-names']);

    const typeLabel = () => {
        return isFrom ? translate(`transport:FROM`) : translate(`transport:TO`);
    };

    return (
        <Box display="flex" alignItems="center">
            <Box mr={1}>
                <Chip sx={{ minWidth: 80 }} label={typeLabel()} />
            </Box>
            <Box mr={1} flex="1 0 auto">
                <Box>{location?.name}</Box>
                <Box>
                    <Typography variant="caption">
                        {location?.streetAddress}
                        {location?.zipCode}, {location?.city},{' '}
                        {translate(`country-names:COUNTRY_${location?.countryCode}`)}
                    </Typography>
                </Box>
            </Box>
            <Box>{translate(transportDateHelper.transportDateFormatter(date, 'date'))}</Box>
        </Box>
    );
};

export default TransportPoint;
